<div class="mate-timepicker-actions">
  <button mat-raised-button (click)="clickCancel.emit()">Cancel</button>
  <button mat-raised-button color="primary" (click)="clickOk.emit()">Ok</button>
</div>
